'use strict';

import { SetYouTube } from './module/SetYouTube';
import { SetAnimation } from './module/SetAnimation';
import { SetValue } from './module/SetValue';



document.addEventListener('DOMContentLoaded', () => {

	//YouTube API
  let tag = document.createElement('script');
  tag.src = "https://www.youtube.com/iframe_api";
  let firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

	SetYouTube();
  SetAnimation();
  SetValue();

});
